export const baseURL = "https://db.ygoprodeck.com/api/v7/cardinfo.php";
export const baseICON =
  "https://www.yugioh-card.com/en/wp-content/uploads/2020/09/neuron_logo_550x550.png";
export const baseErrorPage =
  "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgs-skOPq_G8l69zoNtlYK-68w-0dI4mTIPJgpcavDo5Q9OAndgpL8QgatrH-PAeWZb6vb47or_6ptIPFrYsaLtB5BUzz35Pu1vG71y_NpWunxzI4y0xi44fMcMXoEBkByrBCCT-dBNo7O1/s1600/page-under-construction.png";
